import styled from 'styled-components';
import { StockModelCardCaptionStyled } from '../StockModelCardCaptionStyled';
import { rem } from 'polished';

export const StockModelCardCaptionStyledAP = styled(StockModelCardCaptionStyled)`
    .stockModelCard-imageContainer--info {
        margin-top: ${rem(10)};
        &__list {
            dd {
                font-size: ${rem('12px')};
            }
        }
    }

    .highlighted-text {
        font-size: ${rem('12px')};
    }
`;
